import React, { Component } from "react";
import logo from "../../assets/images/logo.png";
import { connect } from "react-redux";
import { passResetEmail } from "../../redux/store/actions/authActions";
import { Redirect } from "react-router-dom";
import { Link } from "react-router-dom";

class ResetPass extends Component {
  state = {
    email: ""
  };
  handleChange = e => {
    this.setState({
      [e.target.id]: e.target.value
    });
  };
  handleSubmit = e => {
    e.preventDefault();
    // console.log(this.state);
    this.props.passResetEmail(this.state);
  };
  render() {
    const { authError, auth } = this.props;
    // console.log(this.props);
    if (auth.uid) return <Redirect to="/" />;

    return (
      <div className="container pt p-x-15">
        <div className="center-align">
          <img src={logo} alt="" style={{ width: "150px" }} />
        </div>
        <br />
        <Link to="/entrar">Atras</Link>
        <div className="center-align pt">
          <h5>Recuperar contraseña</h5>
          <p>
            Introduce el email con el que te registraste y te enviaremos una
            nueva contraseña.
          </p>
          <form onSubmit={this.handleSubmit} className="white">
            <div className="input-field">
              <i className="material-icons prefix indigo-text text-accent-4">
                alternate_email
              </i>
              <label htmlFor="email">Email</label>
              <input type="email" id="email" onChange={this.handleChange} />
            </div>
            <div className="red-text center">
              {authError ? <p>{authError}</p> : null}
            </div>
            <div className="input-field center-align pt">
              <button className="btn btn-large btn-block indigo accent-4">
                ENVIAR
              </button>
              <Link to="/registrarse">REGISTRARME</Link>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    authError: state.auth.authError,
    auth: state.firebase.auth
  };
};

const mapDispatchToProps = dispatch => {
  // console.log(state);
  return {
    passResetEmail: credentials => dispatch(passResetEmail(credentials))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ResetPass);
